import './Footer.css';
import kcrmLogo from '../../assets/kcrmlogo.png';
import SocialMediaIcons from '../SocialMediaIcons/SocialMediaIcons';

export default function Footer() {
    return (
        <div className='footer'>
            <div className='footer-lower-half'>
                <img src={kcrmLogo} alt='Kansas City Riichi Mahjong Club Logo' />
                <div className='footer-mission-statement'>
                    <h3>Our Mission</h3>
                    <p>We are a group that plays specifically Japanese (Riichi) Mahjong. Whether you are a seasoned player or someone who wishes to learn more about the game, we welcome all players to join us at our public meet-ups or through our socials.</p>
                </div>
                <div className='footer-social'>
                    <h3>Reach out to us!</h3>
                    <SocialMediaIcons noEmailIcon={false} />
                </div>
            </div>
        </div>
    );
}